// extracted by mini-css-extract-plugin
export default {"container":"JsonViewer_container__YVMZQ","copyToClipBoardButton":"JsonViewer_copyToClipBoardButton__Zkglq"};